export enum ESnackbarType {
  Success = 'snackbar-success',
  Error = 'snackbar-error',
}
